import React, { Component, PropTypes } from 'react';
import { browserName, browserVersion } from 'react-device-detect';
import axios from 'axios';
import { Input, Table, TabContent, TabPane, Nav, NavItem, NavLink, Button } from 'reactstrap';
import classnames from 'classnames';
import { VendSystems } from '././vendSystems';
import moment from 'moment';

export class VendUsers extends Component {
    static displayName = VendUsers.name;

    constructor(props) {
        super(props);
        this.state = {
            returnable: [],
            browser: `${browserName}${browserVersion}`,
            ip: "",
            loading: this.props.renderSource == null ? false : true,
            userList: this.props.userList,
            userActive: this.props.userpk,
            tabActive: null
        }
        if (this.props.renderSource == null) { this.getUserList(); }
        
    }

    async getUserList() {
        let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let toSend = {
            userLevel: this.props.userData.level
        }
        const response = await fetch('GetVendUsers', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        });
        const data = await response.json();
        localStorage.setItem("lastFetch", moment());
        this.setState({
            userList: data
        })
    }

    componentDidMount() {

    }

    componentDidUpdate(prevProps, prevState) {

    }

    tabToggle(tab) {
        if (this.state.tabActive !== tab) {
            this.setState({
                tabActive: tab
            });
        }
    }

    isAfterToday(date) {
        return new Date(date).valueOf() > new Date().valueOf();
    }

    showDataView() {
        let thisUser = []
            thisUser = this.state.userList.filter(filter => {
                return filter.pk === this.state.userActive
            })
        return (<div>
            <Table>
                <thead>
                    <tr>
                        <th>PK</th>
                        <th>System</th>
                        <th>Logon</th>
                        <th>Username</th>
                        {/*<th>PW</th>*/}
                        <th>Start Date</th>
                        <th>End Date</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>{thisUser[0].pk}</td>
                        <td>{thisUser[0].sysname}</td>
                        <td>{thisUser[0].logonurl}</td>
                        <td>{thisUser[0].username}</td>
                        {/*<td>{thisUser[0].pk}</td>*/}
                        <td>{thisUser[0].startdate.substring(0, thisUser[0].startdate.indexOf(' '))}</td>
                        <td style={{ color: !this.isAfterToday(thisUser[0].enddate) ? "red" : "black" }}>{thisUser[0].enddate.substring(0, thisUser[0].enddate.indexOf(' '))}</td>
                    </tr>
                </tbody>
            </Table>
            <p />
            <Nav tabs>
                {this.props.renderSource !== "sys" && <NavItem>
                    <NavLink className={classnames({ active: this.state.tabActive === '1' })} onClick={() => this.tabToggle('1')}>
                        Systems
                    </NavLink>
                </NavItem>}
            </Nav>
            <TabContent activeTab={this.state.tabActive}>
                {this.props.renderSource !== "sys" && <TabPane tabId='1'>
                    {thisUser.length > 0 && <div className="vendorChild"><VendSystems userData={this.props.userData} syspk={thisUser[0].vendsystempk} renderSource={"user"} /></div>}
                </TabPane>}
            </TabContent>
        </div>)
    }

    render() {
        let displayView = <div></div>
        if (this.state.loading) { displayView = this.showDataView(); }
        return (<div>
            {this.props.userpk == null && <h2>Users</h2>}<p />
            {this.props.userpk == null && <Input type="select" name="user" id="user" defaultValue="DEFAULT" onChange={(e) => this.setState({userActive: e.target.value, loading: true})}>
                <option value="DEFAULT" disabled>Select...</option>
                {this.state.userList.map(item => (
                    <option value={item.pk}>{item.username}</option>
                ))}
            </Input>}
            <br />
            {this.state.userActive !== null && displayView}
        </div>)
    }
}